module.exports = __webpack_public_path__ + "img/9.747b247.png";